import BaseApi from './base';

class Log extends BaseApi {
    endpoint = 'logs';
}

export default new Log();




// WEBPACK FOOTER //
// ./src/psuite-js/apis/logger/log.js